<mat-progress-bar mode="buffer" [class.dense]="dense"></mat-progress-bar>
